import moment from "moment";
import * as XLSX from "xlsx";

export default function MultipleUrlValidator({
  results,
  handleSubmit,
  handleFileChange,
  loading,
  error,
  file,
  handleResetEncryption,
}) {
  const onHandleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(results);
    const timestamp = moment().format("YYYY_MMMM_Do_h-mm-ss-a");
    const fileName = `${file.name.split(".")[0]}_${timestamp}.xlsx`;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, fileName);
  };
  return (
    <>
      <div
        style={{ backgroundColor: "#e7f3fe", borderLeft: "6px solid #2196f3" }}
      >
        <p>
          <strong className="ml-1 my-2">Note!</strong> Upload Excel ....
        </p>
      </div>
      <div className="d-flex align-items-center">
        <input
          className="form-control mr-3"
          id="formFileSm"
          type="file"
          onChange={handleFileChange}
        />
        <button
          className="btn btn-primary mr-3"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Processing..." : "Submit"}
        </button>
        <button
          type="button"
          className="btn btn-warning mr-3"
          onClick={handleResetEncryption}
        >
          Reset
        </button>
        <button type="button"
          className="btn btn-success"
          disabled={results.length <= 0}
          onClick={onHandleDownload}>download</button>
      </div>

      {error && <div className="text-danger mt-2">{error}</div>}

      {/* {results.length > 0 && ( */}
      <div className="smartTable-tableContainer-ipAddressTable mt-4">
        <table className="smartTable-table table table-striped border">
          <thead lassName="smartTable-thead">
            <tr>
              {/* {Object.hasOwn(results[0], "isExists") && <th>Path</th>} */}
              <th >Exists </th>

            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => {
              const className = result.isExists ? "text-success" : "text-danger"
              return (
                <tr key={index}>
                  <td className={`font-weight-semibold ${className}`} >
                    {result.filePath || result.url}
                  </td>
                  {Object.hasOwn(result, "isExists") && (
                    <td className={`font-weight-bold ${className}`} >
                      {String(result.isExists)}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      {/* )} */}
    </>
  );
}
